'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAutosuggest = require('react-autosuggest');

var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);

var _debounce = require('lodash/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _nitroText = require('../nitro-text');

var _nitroText2 = _interopRequireDefault(_nitroText);

var _nitroIcon = require('../nitro-icon');

var _nitroIcon2 = _interopRequireDefault(_nitroIcon);

var _nitroLoading = require('../nitro-loading');

var _nitroLoading2 = _interopRequireDefault(_nitroLoading);

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NitroAutoCompleteSearchBox = function (_Component) {
  _inherits(NitroAutoCompleteSearchBox, _Component);

  function NitroAutoCompleteSearchBox(props) {
    _classCallCheck(this, NitroAutoCompleteSearchBox);

    var _this = _possibleConstructorReturn(this, (NitroAutoCompleteSearchBox.__proto__ || Object.getPrototypeOf(NitroAutoCompleteSearchBox)).call(this, props));

    _this.handleKeyPress = function (event) {
      if (event.key === 'Enter') {
        _this.props.onEnter();
      }
    };

    _this.renderEnterSymbol = function () {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _styles.EnterIconSpan,
          null,
          _react2.default.createElement(_nitroIcon2.default, { name: 'enter', size: 55, variant: _this.props.variant })
        ),
        _react2.default.createElement(
          _styles.EnterIconHelperSpan,
          null,
          _react2.default.createElement(
            _nitroText2.default,
            { size: '10', variant: 'base3' },
            _this.props.enterText
          )
        )
      );
    };

    _this.resultsFetchRequestedDebounced = (0, _debounce2.default)(props.resultsFetchRequested, props.debounceDuration);
    return _this;
  }

  _createClass(NitroAutoCompleteSearchBox, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var originalInputProps = {
        disabled: this.props.disabled,
        placeholder: this.props.placeholder,
        value: this.props.searchTerm,
        onChange: this.props.onSearchTermChange,
        onKeyPress: this.handleKeyPress,
        style: {
          width: this.props.width,
          height: this.props.height
        },
        onBlur: this.props.onBlur,
        onFocus: this.props.onFocus
      };

      return _react2.default.createElement(
        _styles.StyledAutoSuggest,
        { className: this.props.className },
        _react2.default.createElement(_reactAutosuggest2.default, {
          suggestions: this.props.results,
          focusInputOnSuggestionClick: this.props.focusInputOnSuggestionClick,
          onSuggestionsFetchRequested: this.resultsFetchRequestedDebounced,
          onSuggestionsClearRequested: this.props.resultsClearRequested,
          getSuggestionValue: this.props.onResultSelect,
          renderSuggestion: this.props.renderResults,
          shouldRenderSuggestions: this.props.shouldRenderSuggestions,
          inputProps: originalInputProps,
          renderSuggestionsContainer: this.props.renderSuggestionsContainer,
          onSuggestionSelected: this.props.onSuggestionSelected,
          ref: this.props.getReference,
          renderInputComponent: function renderInputComponent(inputProps) {
            var wrapperStyle = {
              position: 'relative'
            };

            var inputFieldStyle = {
              paddingLeft: '50px',
              paddingRight: '24.2%',
              width: '100%'
            };

            if (_this2.props.searchMagnifyGlass || _this2.props.searchInputClose || _this2.props.enterSymbol) {
              Object.assign(inputProps.style, inputFieldStyle);
              return _react2.default.createElement(
                'div',
                { style: wrapperStyle },
                _react2.default.createElement('input', inputProps),
                _this2.props.searchMagnifyGlass && _react2.default.createElement(
                  _styles.SearchIconSpan,
                  { showBack: _this2.props.showBackOnMobile },
                  _react2.default.createElement(_nitroIcon2.default, {
                    name: 'search',
                    size: 16,
                    variant: _this2.props.variant
                  })
                ),
                _this2.props.showBackOnMobile && _react2.default.createElement(
                  _styles.BackIcon,
                  {
                    showBack: _this2.props.showBackOnMobile,
                    onClick: _this2.props.backAction
                  },
                  _react2.default.createElement(_nitroIcon2.default, {
                    name: 'arrow-back',
                    size: 16,
                    variant: _this2.props.variant
                  })
                ),
                _this2.props.showLoading && _react2.default.createElement(
                  _styles.LoadingSpan,
                  null,
                  _react2.default.createElement(_nitroLoading2.default, {
                    size: 22,
                    thickness: 2,
                    variant: 'secondary'
                  })
                ),
                _this2.props.searchInputClose && _react2.default.createElement(
                  _styles.CrossIconSpan,
                  null,
                  _react2.default.createElement(_nitroIcon2.default, {
                    name: 'close',
                    size: 12,
                    variant: _this2.props.variant
                  })
                ),
                _this2.props.enterSymbol && _this2.renderEnterSymbol()
              );
            }

            return _react2.default.createElement('input', inputProps);
          }
        })
      );
    }
  }]);

  return NitroAutoCompleteSearchBox;
}(_react.Component);

NitroAutoCompleteSearchBox.propTypes = {
  className: _propTypes2.default.string,
  searchTerm: _propTypes2.default.string.isRequired,
  placeholder: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  enterText: _propTypes2.default.string,
  onSearchTermChange: _propTypes2.default.func,
  renderResults: _propTypes2.default.func.isRequired,
  resultsFetchRequested: _propTypes2.default.func.isRequired,
  resultsClearRequested: _propTypes2.default.func.isRequired,
  onResultSelect: _propTypes2.default.func.isRequired,
  results: _propTypes2.default.array.isRequired,
  width: _propTypes2.default.string,
  height: _propTypes2.default.string,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  shouldRenderSuggestions: _propTypes2.default.func,
  searchMagnifyGlass: _propTypes2.default.bool,
  searchInputClose: _propTypes2.default.bool,
  enterSymbol: _propTypes2.default.bool,
  renderSuggestionsContainer: _propTypes2.default.func,
  onSuggestionSelected: _propTypes2.default.func,
  onEnter: _propTypes2.default.func,
  variant: _propTypes2.default.string,
  showLoading: _propTypes2.default.bool,
  showBackOnMobile: _propTypes2.default.bool,
  backAction: _propTypes2.default.func,
  getReference: _propTypes2.default.func,
  focusInputOnSuggestionClick: _propTypes2.default.bool
};

NitroAutoCompleteSearchBox.defaultProps = {
  enterText: 'to search',
  debounceDuration: 500,
  results: [],
  resultsFetchRequested: function resultsFetchRequested() {
    return null;
  }
};

exports.default = NitroAutoCompleteSearchBox;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-auto-complete-search-box/NitroAutoCompleteSearchBox.js
// module id = 2881
// module chunks = 4